import { connect } from 'react-redux'
import ForgotPassword from './forgot-password'
import { isEmailSentSuccessfully } from './redux/forgot-password.selectors'

const mapStateToProps = state => ({
  showSuccessScreen: isEmailSentSuccessfully(state)
})

export default connect(
  mapStateToProps,
  null
)(ForgotPassword)
